import { render, staticRenderFns } from "./GeneralSettingDeliveryBlackoutsWeekdays.vue?vue&type=template&id=47808736&"
import script from "./GeneralSettingDeliveryBlackoutsWeekdays.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingDeliveryBlackoutsWeekdays.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports